import { Moment } from 'moment';

import { make, makeMoment, makeUnix } from './Model';
import { TOCStatus } from './TOCStatus';

export class MemberDashboardTOC {
  admitDate?: Moment;

  businessDaysSinceDischargeDate?: number;

  daysInpatient?: number;

  dischargeDate?: Moment;

  status: TOCStatus;

  statusUpdatedAt?: Moment;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.admitDate = makeMoment(obj.admitDate);
    this.dischargeDate = makeMoment(obj.dischargeDate);
    this.status = make(obj.status, TOCStatus);
    this.statusUpdatedAt = makeUnix(obj.statusUpdatedAt);
  }
}

export default MemberDashboardTOC;
